
function getImageUrlByHash(hash, dataArray) {
  const defaultLogo = "https://autobetlottery.com/static/media/logo.b714e7ab.png";
  if (!hash) {
    return defaultLogo;
  }

  // If dataArray is already a resolved string URL, return it directly
  if (typeof dataArray === "string") {
    return dataArray.startsWith("http") ? dataArray : defaultLogo;
  }

  let list = dataArray;
  if (dataArray && typeof dataArray === "object" && !Array.isArray(dataArray)) {
    if (Array.isArray(dataArray.result)) {
      list = dataArray.result;
    } else if (Array.isArray(dataArray.data)) {
      list = dataArray.data;
    }
  }

  if (!Array.isArray(list)) {
    return defaultLogo;
  }

  const foundItem = list.find((item) => item && item.logoHash === hash);
  if (foundItem && foundItem.imageUrl) {
    return foundItem.imageUrl;
  }

  return defaultLogo;
}

export default getImageUrlByHash;

  